import { LANDING } from "@/constants/testIds";

const PILLARS = [
  { title: "Energy", body: "Proactive, committed, and giving every client his full attention." },
  { title: "Passion", body: "Genuinely loves property and helping people move forward." },
  { title: "Results", body: "Focused on smart strategies that deliver the best outcomes." },
  { title: "Straight-up advice", body: "Clear, honest guidance that you can count on." },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid={LANDING.about}
      className="relative bg-[#FAFAF7] py-24 md:py-28 lg:py-32 border-y border-[#E6E3D9]"
    >
      <div className="max-w-[1280px] mx-auto px-5 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="overline mb-5">About James</div>
            <h2
              data-testid={LANDING.aboutH2}
              className="font-display text-[2.4rem] sm:text-[3rem] lg:text-[3.4rem] leading-[1.05] tracking-tight text-[#0E0E0E]"
            >
              A steady mix of <span className="font-display-italic">experience,<br />
              honesty,</span> and drive.
            </h2>

            <blockquote className="mt-9 border-l-4 border-[#FFE512] pl-5">
              <p className="font-display-italic text-xl md:text-[1.4rem] text-[#0E0E0E] leading-[1.35]">
                &ldquo;Real estate works best when it&rsquo;s built on trust, genuine relationships, and a shared goal of getting the best result possible.&rdquo;
              </p>
              <footer className="mt-3 text-[10.5px] uppercase tracking-[0.22em] font-semibold text-[#888880]">
                — James Townsend
              </footer>
            </blockquote>
          </div>

          <div className="lg:col-span-7 space-y-5 text-[16.5px] text-[#2B2B2B] leading-[1.75]">
            <p>
              James Townsend brings a steady mix of experience, honesty and drive to
              real estate. With more than two decades in business, including
              running his own retail flooring company and managing a working
              avocado orchard, he understands the importance of hard work,
              clear communication, and doing things properly.
            </p>
            <p>
              A lifelong interest in property has led James through every stage of
              the journey: from first renovations to managing larger investment and
              development projects. That hands-on experience gives him practical
              insight into what adds real value and how to help clients
              make confident decisions.
            </p>
            <p>
              Based in Mount Maunganui &amp; Papamoa, James combines local insight
              with a down-to-earth style that makes people feel comfortable and
              informed.
            </p>
          </div>
        </div>

        {/* Pillars — James's approach */}
        <div className="mt-16 md:mt-20">
          <div className="overline mb-7">James&rsquo;s approach</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {PILLARS.map((p, i) => (
              <article
                key={p.title}
                className="card-hover bg-white rounded-sm p-6 md:p-7 border border-[#E6E3D9]"
              >
                <div className="flex items-center justify-between mb-5">
                  <span className="font-display-italic text-xl text-[#0E0E0E]">{String(i + 1).padStart(2, "0")}</span>
                  <span className="block w-7 h-[3px] bg-[#FFE512]" />
                </div>
                <h3 className="font-display text-[1.55rem] tracking-tight text-[#0E0E0E]">
                  {p.title}
                </h3>
                <p className="mt-2.5 text-[14px] text-[#4A4A4A] leading-[1.65]">
                  {p.body}
                </p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
